module.exports = __webpack_public_path__ + "img/IOI_Square_Black_White.2ccb80fc.png";